import {
    CREATE_BASELINE,
    CREATE_BASELINE_SESSION,
    DELETE_BASELINE,
    DELETE_BASELINE_SESSION,
    EDIT_BASELINE,
    EDIT_BASELINE_SESSION,
    GET_BASELINE_GRAPH,
    GET_BASELINES,
} from './baseline.types';

/** Baselines */

export const getBaselines = (params, load) => {
    return {
        type: GET_BASELINES,
        payload: { params, load },
    };
};

export const createBaseline = (body) => {
    return {
        type: CREATE_BASELINE,
        payload: { body },
    };
};

export const createBaselineSession = (baselineId, body) => {
    return {
        type: CREATE_BASELINE_SESSION,
        payload: { baselineId, body },
    };
};

export const editBaseline = (id, body) => {
    return {
        type: EDIT_BASELINE,
        payload: { id, body },
    };
};

export const editBaselineSession = (baselineId, sessionId, body) => {
    return {
        type: EDIT_BASELINE_SESSION,
        payload: { baselineId, sessionId, body },
    };
};

export const deleteBaselineSession = (baselineId, sessionId) => {
    return {
        type: DELETE_BASELINE_SESSION,
        payload: { baselineId, sessionId },
    };
};

/** End */
